<template>
  <div>
    <form action>
      <label for="title">Título do serviço</label>
      <input type="text" name="title" v-model="form.title" />

      <label for="serviceImg">Imagem do serviço</label>
      <input
        type="file"
        id="serviceImg"
        name="serviceImg"
        ref="image"
        accept="image/*"
        @change="handleFileUpload"
      />

      <label for>Descrição</label>
      <!-- <ckeditor :editor="editor" v-model="form.description" :config="editorConfig"></ckeditor> -->
      <button @click.prevent="createService">Adicionar</button>
    </form>
    {{form.description}}
  </div>
</template>

<script>
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { db } from "@/db.js";
import firebase from "firebase";

export default {
  data() {
    return {
      // editor: ClassicEditor,
      // editorData: "",
      editorConfig: {},
      form: {
        title: "",
        description: ""
      },
      img: "",
      imgUrl: "",
      imgAlt: "",
      uploadValue: 0
    };
  },
  methods: {
    handleFileUpload() {
      this.img = this.$refs.image.files[0];
    },
    formatService() {
      // const form = new FormData();
      // const imgName = this.form.title.split(" ").join("-");
      // form.append(imgName, this.imgUrl);
      // form.append("imgAlt", imgName);
      // form.append("title", this.form.title);
      // form.append("description", this.form.description);
      let data = {
        title: this.form.title,
        description: this.form.description,
        imgUrl: this.imgUrl,
        imgAlt: this.form.title
      };
      return data;
    },
    createService() {
      const storageRef = firebase
        .storage()
        .ref(`${this.form.title.split(" ").join("-")}`)
        .put(this.img);
      storageRef.on(
        "state_changed",
        snapshot => {
          this.uploadValue =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        },
        error => {
          console.log(error.message);
        },
        () => {
          this.uploadValue = 100;
          storageRef.snapshot.ref.getDownloadURL().then(url => {
            this.imgUrl = url;
            console.log(url);
            let data = this.formatService();
            db.collection("services").add(data);
          });
        }
      );
    }
  }
};
</script>

<style scoped lang="scss">
input {
  display: block;
}
</style>